(function ( $ ){

	var defaults = {

		duration: 8000,

		transitions: {

			slide: {
				start: {
					opacity: 0,
					left: "100%"
				},

				end: {
					opacity: 1,
					left: 0
				},
				duration: 500
			},

			fade: {
				start: {
					opacity: 0,
					left: 0
				},
				end: {
					opacity: 1,
					left: 0
				},
				duration: 2000
			}

		},

		fadein: 400

	};

	defaults.transition = defaults.transitions.slide;


	$.fn.srzsdSlider = function(options){

		var options = options || {};

		return this.each(function(){

			var kontext = $(this);


				/* Einstellungen über Methode */

			if (typeof options.transition !== "undefined" && typeof defaults.transitions[options.transition] !== "undefined"){
				options.transition = defaults.transitions[options.transition];
			} else {
				delete options.transition;
			}


				/* Einstellungen über Data-Attribute */

			var data = {
				duration: kontext.data("duration"),
				transition: kontext.data("transition")
			}

			if (typeof data.transition !== "undefined" && typeof defaults.transitions[data.transition] !== "undefined"){
				data.transition = defaults.transitions[data.transition];
			} else {
				delete data.transition;
			}


				/* Einstellungen vereinen */


			var settings = $.extend({}, defaults, options, data);

			new Slider(kontext, settings);

		});

	};


	var Slider = function(kontext, settings){

		var self = this;

		if ($("li", kontext).length === 0){
			return false;
		}

		this.kontext = kontext;
		this.settings = settings;
		this.counter = 0;

		var container = $("> ul, > ol", this.kontext).eq(0);


			/* Inhalte erfassen */

		this.inhalte = [];

		$("> li", container).each(function(index){

				/* Parallaxing */

			$(this).find(".parallaxing").each(function(index){

				var element = $(this).removeClass("parallaxing");

				var wrapper = $('<div />').insertAfter(element).append(element).css({
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%"
				}).addClass("parallaxing");

			});


				/* Inhalt */

			var html = $(this).html();

			var inhalt = {
				container: $(this),
				inhalt: $(this).children(),
				html: function(){ return html; },
				parallaxing: $(this).find(".parallaxing")
			};

			self.inhalte.push(inhalt);

			if (index >= 2){
				$(this).remove();
			}

		});

		if (this.inhalte.length < 2){
			return false;
		}

			/* Navigation */

		if (this.inhalte.length > 1 && $(".srzsd-slider-nav", this.kontext).length !== -1){

			this.navigation = $(".srzsd-slider-nav", this.kontext);

			var liste = $("<ol/>").appendTo(this.navigation);

			for (var i = 0; i < this.inhalte.length; i++){


				$('<li>' + (i + 1) + '</li>').appendTo(liste).data("position", i).click(function(){
					self.wechsel($(this).data("position"));
				});

			}

			$("li", this.navigation).eq(0).addClass("current");

		}


			/* Slides anlegen */

		this.slides = [
			this.inhalte[0].container,
			this.inhalte[1].container
		];

		this.slides[0].css({
			display: "block",
			width: "100%",
			height: "100%",
			opacity: 0
		});

		this.slides[1].css({
			display: "block",
			width: "100%",
			height: "100%",
			position: "absolute",
			top: 0,
			left: 0,
			opacity: 0
		});

		container.css({
			overflow: "hidden",
			position: "relative"
		}).click(function(){
			self.wechsel();
		});


			/* Slider einblenden */

		this.kontext.removeClass("js-hidden");

		this.slides[0].empty().append(this.inhalte[0].inhalt).delay(500).animate(
			{
				opacity: 1
			},
			this.settings.fadein,
			function (){

				if (self.inhalte.length > 1){
					self.kontext.addClass("aktiv");
				}

			}
		);


	};


	Slider.prototype.timer = function(starten){

		var self = this;

		var starten = (starten !== false)?true:false;

		if (! starten || this.intervall){

			clearInterval(this.intervall);
			this.intervall = null;

		}

		if (starten){

			this.intervall = setInterval(
				(function(i) {
					return function() {
						i.wechsel()
					}
				})(self),
				self.settings.duration + self.settings.fadein
			);

		}

	};


	Slider.prototype.wechsel = function(position){

		var self = this;

		this.timer(false);

		if (! this.kontext.hasClass("aktiv") || position === this.counter){
			this.timer();
			return false;
		}

		this.counter = (typeof position !== "undefined")?position:(this.counter + 1) % this.inhalte.length;

		this.kontext.removeClass("aktiv");

		$("li", this.navigation).removeClass("current");
		$("li", this.navigation).eq(this.counter).addClass("current");

		this.slides[1].stop().css(
			this.settings.transition.start
		);

		this.slides[1].empty().append(this.inhalte[this.counter].inhalt).animate(
			this.settings.transition.end,
			this.settings.transition.duration,
			function(){


//				self.slides[0].css("height", self.slides[0].height()).empty().append(self.inhalte[self.counter].inhalt);
//
//				window.setTimeout(
//					function(){
//						self.slides[0].css("height", "auto");
//					},
//					200
//				);

				self.slides[0].empty().append(self.inhalte[self.counter].inhalt);

				self.kontext.addClass("aktiv");
				self.timer();

			}

		);

		if (defaults.transition === defaults.transitions.slide){

			this.inhalte[this.counter].parallaxing.stop().css({
				left: "-80%",
				opacity: 0
			});

			this.inhalte[this.counter].parallaxing.animate(
				{
					left: 0,
					opacity: 1
				},
				this.settings.transition.duration
			);

		}


	};

}( jQuery ));